export const sleep = (callback: () => void, ms: number) =>
  setTimeout(callback, ms);
